import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  InputLabel,
  FormControl,
  Select,
  ListItemText,
  Checkbox,
  Input,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Tooltip,
  TextField,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import MultiTextField from "./MultiTextField";
import { editField, deleteArrayItem } from "../redux";
import config from "../utils/config";

import SelectorDMA from "./TargetingSelectors/SelectorDMA";
import SelectorZIP from "./TargetingSelectors/SelectorZIP";

export default ({ i }) => {
  const [isOpen, setIsOpen] = useState(false);
  const targeting = useSelector(({ file: { root } }) => root[i].targeting);

  const dispatch = useDispatch();
  const hasTargeting = Object.keys(targeting).reduce((hasTargeting, key) => {
    return hasTargeting || !!targeting[key].length;
  }, false);

  const handleDataList = (value) => {
    if (isNaN(value[value.length - 1]) && value[value.length - 1] !== ",") {
      value = value.slice(0, -1);
    }
    /* eslint-disable */
    const numberList = value.split(",").map((item) => {
      if (Number(item) > 0) return Number(item);
    });
    /* eslint-enable */

    return Array.from(new Set(numberList));
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        style={{
          color: !hasTargeting ? "red" : "green",
          borderColor: !hasTargeting ? "red" : "green",
        }}
        size="small"
        onClick={() => setIsOpen(true)}
      >
        {hasTargeting ? "Edit" : "Add"} Targeting
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Targeting</DialogTitle>
        <DialogContent>
          <FormControl fullWidth style={{ marginTop: ".5rem" }}>
            <InputLabel shrink htmlFor="select-multiple-checkbox">
              Models
            </InputLabel>
            <Select
              multiple
              value={targeting.models}
              onChange={(e) =>
                dispatch(
                  editField(`root[${i}].targeting.models`, e.target.value)
                )
              }
              inputProps={{ width: 500 }}
              input={<Input id="select-multiple-checkbox" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {config.models.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox
                    color="primary"
                    checked={targeting.models.indexOf(name) > -1}
                  />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth style={{ marginTop: ".5rem" }}>
            <InputLabel shrink htmlFor="select-multiple-checkbox">
              State
            </InputLabel>
            <Select
              multiple
              value={targeting.state}
              onChange={(e) =>
                dispatch(
                  editField(`root[${i}].targeting.state`, e.target.value)
                )
              }
              inputProps={{ width: 500 }}
              input={<Input id="select-multiple-checkbox" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {config.state.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox
                    color="primary"
                    checked={targeting.state.indexOf(name) > -1}
                  />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth style={{ marginTop: ".5rem" }}>
            <InputLabel shrink htmlFor="select-multiple-checkbox">
              Internet
            </InputLabel>
            <Select
              multiple
              value={targeting.internet}
              onChange={(e) =>
                dispatch(
                  editField(`root[${i}].targeting.internet`, e.target.value)
                )
              }
              inputProps={{ width: 500 }}
              input={<Input id="select-multiple-checkbox" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {config.internet.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox
                    color="primary"
                    checked={targeting.internet.indexOf(name) > -1}
                  />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth style={{ marginTop: ".5rem" }}>
            <InputLabel shrink htmlFor="select-multiple-checkbox">
              Environment
            </InputLabel>
            <Select
              multiple
              value={targeting.environment}
              onChange={(e) =>
                dispatch(
                  editField(`root[${i}].targeting.environment`, e.target.value)
                )
              }
              inputProps={{ width: 500 }}
              input={<Input id="select-multiple-checkbox" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {config.environment.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox
                    color="primary"
                    checked={targeting.environment.indexOf(name) > -1}
                  />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth style={{ marginTop: ".5rem" }}>
            <InputLabel shrink htmlFor="select-multiple-checkbox">
              Time Zones
            </InputLabel>
            <Select
              multiple
              value={targeting.timezone}
              onChange={(e) => {
                dispatch(
                  editField(`root[${i}].targeting.timezone`, e.target.value)
                );
              }}
              inputProps={{ width: 500 }}
              input={<Input id="select-multiple-checkbox" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {config.timezone.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox
                    color="primary"
                    checked={targeting.timezone.indexOf(name) > -1}
                  />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div style={{ marginTop: ".5rem" }}>
            <MultiTextField
              label="times"
              placeholder="Enter Time (0900-1000)"
              values={targeting.times}
              onDelete={(j) => {
                dispatch(deleteArrayItem(`root[${i}].targeting.times`, j));
              }}
              onChange={(val, j) =>
                dispatch(editField(`root[${i}].targeting.times[${j}]`, val))
              }
            />
          </div>
          <div style={{ marginTop: ".5rem" }}>
            <Tooltip title={config.tooltipStr}>
              <span>
                <MultiTextField
                  label="rxid"
                  placeholder="Enter ReceiverID regex"
                  values={targeting.rxid}
                  onDelete={(j) => {
                    dispatch(deleteArrayItem(`root[${i}].targeting.rxid`, j));
                  }}
                  onChange={(val, j) =>
                    dispatch(editField(`root[${i}].targeting.rxid[${j}]`, val))
                  }
                />
              </span>
            </Tooltip>
          </div>
          <div style={{ marginTop: ".5rem" }}>
            <Tooltip title={config.tooltipStr}>
              <span>
                <MultiTextField
                  label="swid"
                  placeholder="Enter SWID regex"
                  values={targeting.swid}
                  onDelete={(j) => {
                    dispatch(deleteArrayItem(`root[${i}].targeting.swid`, j));
                  }}
                  onChange={(val, j) =>
                    dispatch(editField(`root[${i}].targeting.swid[${j}]`, val))
                  }
                />
              </span>
            </Tooltip>
          </div>
          <div style={{ marginTop: ".5rem" }}>
            <TextField
              type="number"
              placeholder="Enter number bandwidth, bps"
              label="Bandwidth"
              value={targeting.bandwidth}
              margin="dense"
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                dispatch(
                  editField(
                    `root[${i}].targeting.bandwidth`,
                    Number(e.target.value)
                  )
                )
              }
              InputProps={{
                inputProps: { min: 0 },
              }}
              fullWidth
            />
          </div>
          <div style={{ marginTop: ".5rem" }}>
            <TextField
              placeholder="Enter DMA with comma separator"
              label="DMA"
              value={targeting.dma}
              margin="dense"
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                dispatch(
                  editField(
                    `root[${i}].targeting.dma`,
                    handleDataList(e.target.value)
                  )
                )
              }
              fullWidth
              InputProps={{
                endAdornment: targeting.dma.length ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => {
                        dispatch(editField(`root[${i}].targeting.dma`, []));
                      }}
                    >
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                  </InputAdornment>
                ) : undefined,
              }}
            />

            <SelectorDMA featureNumber={i} />
          </div>
          <div style={{ marginTop: ".5rem" }}>
            <TextField
              placeholder="Enter ZIP with comma separator"
              label="ZIP"
              value={targeting.zip}
              margin="dense"
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                dispatch(
                  editField(
                    `root[${i}].targeting.zip`,
                    handleDataList(e.target.value)
                  )
                )
              }
              fullWidth
              InputProps={{
                endAdornment: targeting.zip.length ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => {
                        dispatch(editField(`root[${i}].targeting.zip`, []));
                      }}
                    >
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                  </InputAdornment>
                ) : undefined,
              }}
            />

            <SelectorZIP featureNumber={i} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
